import React, { useState, useEffect, useContext, useRef } from 'react'
import { DayView, WeekView, MonthView, } from '@devexpress/dx-react-scheduler-material-ui';
import moment from 'moment-timezone';
import { Col, FormControl, InputGroup, Row, Form, Modal, ModalBody, ModalHeader, ModalTitle, ModalFooter } from 'react-bootstrap';
import GlobalContext from '../GlobalContext';
import ServiceContext from '../ServiceContext';
import { useImmer } from 'use-immer';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { RiUserAddLine, RiUserUnfollowLine, RiCheckLine, RiCloseLine, } from 'react-icons/ri'

import TextContext from '../TextContext';
import GoodNumber from '../components/GoodNumber';
import GoodSwitch from '../components/GoodSwitch';

const addMinutes = (h, add) => {
    return moment(h, 'HH:mm').add(add, 'minute').format('HH:mm')
    const hour = parseInt(h.slice(0, 2))
    const minutes = parseInt(h.slice(3, 5))
    let htoadd = parseInt(add / 60)
    let mtoadd = (add - htoadd * 60) + minutes

    htoadd += hour

    if (mtoadd > 60) {
        htoadd += 1
        mtoadd -= 60
    }

    if (htoadd > 23) {
        htoadd = 23
    }


    const hstring = htoadd.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
    })

    const mstring = mtoadd.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
    })

    return `${hstring}:${mstring}`
}
const checkNumber = (number) => {
    const continuos = number.split(" ").join("")
    //console.log("HEY",continuos)
    return (isInteger(continuos) && continuos.length > 6 && continuos.length < 15)
}
const compTime = (a, b, msg) => {
    const au = moment(a, 'HH:mm').unix()
    const bu = moment(b, 'HH:mm').unix()
    console.log(msg, a, b, au, bu, au > bu)
    return au > bu
}
const isInteger = (number) => {
    if (!/^["|']{0,1}[-]{0,1}\d{0,}(.{0,1}\d+)["|']{0,1}$/.test(number)) return false;
    return !(number - parseInt(number));
}

const defaultCustomerValues = {
    cus_name: '',
    cus_surname: '',
    phn_prefix: '+41',
    phn_number: '',
    cus_email: null
}

const EventEditor = () => {

    const [showAdd, setShowAdd] = useState(false)
    const globalContext = useContext(GlobalContext)
    const serviceContext = useContext(ServiceContext)
    const textContext = useContext(TextContext)
    const animatedComponents = makeAnimated();
    const [refreshSelect, setRefreshSelect] = useState(true)
    const [addCustomer, setAddCustomer] = useState(false)
    const [showAddAlert, pippo] = useState(false)
    const [userOptions, setUserOptions] = useState([])
    const [values, setValues] = useImmer({
        date: undefined,
        start: undefined,
        end: undefined,
        allDay: false,
        title: '',
        note: '',
        category: undefined,
        appointment: undefined,
        customer: undefined,
        contact: true,
        autogen_title: true,
        rec_end: null,
        rec_step: null,
        rec_unit: null,
        isRec: false,
        owner: { label: globalContext.get.User.use_username, value: globalContext.get.User.ID }
    })
    const [end, setEnd] = useState(undefined)
    const [formChecks, setFormChecks] = useImmer({
        touched: {
            ID: false,
            date: false,
            start: false,
            end: false,
            allDay: false,
            title: false,
            note: false,
            category: false,
            customer: false,
            owner: false,
            contact: false,
            appointmentID: false,
        },
        check: {
            ID: (v) => { return true },
            date: (v) => { return v },
            start: (v) => { return true },
            end: (v) => { return true },
            allDay: (v) => { return true },
            title: (v) => { return v.length > 0 && v.length < 47 },
            note: (v) => { return v.length < 150 },
            category: (v) => { return v },
            customer: (v) => { return (isAppointment && !addCustomer) ? v : true },
            owner: (v) => { return true },
            contact: (v) => { return true },
            appointmentID: (v) => { return true },
        },
        good: {
            ID: false,
            date: false,
            start: false,
            end: false,
            allDay: false,
            title: false,
            note: false,
            category: false,
            customer: false,
            owner: false,
            contact: false,
            appointmentID: false,
        },
        bad: {
            ID: false,
            date: false,
            start: false,
            end: false,
            allDay: false,
            title: false,
            note: false,
            category: false,
            customer: false,
            owner: false,
            contact: false,
            appointmentID: false,
        },
    })
    const [customerValues, setCustomerValues] = useImmer(defaultCustomerValues)
    const [customerCheckValues, setCustomerCheckValues] = useImmer({
        touched: {
            cus_name: false,
            cus_surname: false,
            phn_prefix: false,
            phn_number: false,
        },
        check: {
            cus_name: (v) => { return v.length > 0 && v.length < 50 },
            cus_surname: (v) => { return v.length < 50 },
            phn_prefix: (v) => { return v.match(/\+[0-9]{1,3}$/) },
            phn_number: (v) => { return checkNumber(v) },
        },
        good: {
            cus_name: false,
            cus_surname: false,
            phn_prefix: false,
            phn_number: false,
        },
        bad: {
            cus_name: false,
            cus_surname: false,
            phn_prefix: false,
            phn_number: false,
        },
    })
    const [recUnitOptions, setRecUnitOptions] = useState([
        { label: textContext.get(['event', 'new_event'], ['day'], textContext.value), value: 'day' },
        { label: textContext.get(['event', 'new_event'], ['week'], textContext.value), value: 'week' },
        { label: textContext.get(['event', 'new_event'], ['month'], textContext.value), value: 'month' },
        { label: textContext.get(['event', 'new_event'], ['year'], textContext.value), value: 'year' },
    ])
    const [timeError, setTimeError] = useState(false)
    const [isAppointment, setIsAppointment] = useState(true)
    const categoryOptions = globalContext.get.categories.map(cat => ({ label: cat.cat_name, value: { ID: cat.ID, apt: cat.cat_apt }, }))
    const [customerOptions, setCustomerOptions] = useState(globalContext.get.customers.map(cus => ({ label: `${cus.cus_name} ${cus.cus_surname ? cus.cus_surname : ''}`, value: cus.ID })))
    const [cusReqID, setCusReqID] = useState(false)
    const altCategory = useRef(undefined)

    const setTime = (cat) => {
        if (cat) {
            const cID = cat.value.ID
            const category = globalContext.get.categories.filter(cati => cati.ID == cID)[0]
            const start = values.start
            //console.log("start" ,addMinutes(start,category.cat_duration))
            setEnd(addMinutes(start, category.cat_duration))
            //setValues(draft=>{draft.end=`${moment(values.start, 'HH:mm').add(category.cat_duration,'minute').format('HH:mm')}`})
        } else {
            return
        }
    }
    const changeRec = (e) => {
        // console.log(e)
        if (e) {
            setValues(draft => {
                draft.rec_end = undefined;
                draft.rec_step = 2;
                draft.rec_unit = { label: textContext.get(['event', 'new_event'], ['day'], textContext.value), value: 'day' };
                draft.isRec = true
            })
        } else {
            setValues(draft => {
                draft.rec_end = null;
                draft.rec_step = null;
                draft.rec_unit = null;
                draft.isRec = false
            })
        }
    }
    const handleSubmit = async () => {
        let customerID = false
        if (addCustomer) {
            const cusAdded = await addCustomerfc(true)
            if (cusAdded) {
                customerID = cusAdded
            } else {
                return
            }
        }
        if (!checkForm(values, formChecks, setFormChecks, true)) {

            console.log('non passato', (isAppointment && !addCustomer), isAppointment ? 'v' : true,)
            return
        }
        if(timeError&&!values.allDay){
            return
        }
        // serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const EventBody = {
            eve_title: values.title,
            eve_note: values.note,
            eve_allDay: values.allDay,
            eve_start: moment(`${values.date} ${values.start}`, "YYYY-MM-DD HH:mm").unix(),
            eve_end: moment(`${values.date} ${end}`, "YYYY-MM-DD HH:mm").unix(),
            Category_ID: values.category.value.ID,
            Shop_ID: globalContext.get.selectedShop.ID,
            eve_owner_ID: values.owner.value,
            eve_autogen_title: values.autogen_title
        }
        if (values.isRec) {
            EventBody.rec_unit = values.rec_unit.value
            EventBody.rec_step = values.rec_step
            if (values.rec_end) {
                EventBody.rec_end = moment(values.rec_end, 'YYYY-MM-DD').unix()
            } else {
                EventBody.rec_end = 0
            }
        }


        if (isAppointment) {
            const AptBody = {
                apt_contact: values.contact,
                Customer_ID: customerID ? customerID : values.customer.value
            }
            const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/appointments`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(AptBody)

            })
            const respValue = await resp.json()

            EventBody.Appointment_ID = respValue.data.ID
        }

        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/events`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(EventBody)
        })

        if (resp.status == 200) {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['add_event'], textContext.value),
                    ttl: 2000
                })
            })
            closeAdd()
            // globalContext.set(draft => { draft.Reloads.events = true })
            if (cusReqID) {
                serviceContext.set(draft => { draft.deleteCusRequest = cusReqID })
                setCusReqID(false)
            }
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_event_add'], textContext.value),
                    ttl: 2000
                })
            })
        }
        // serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    }
    const addCustomerfc = async (final = false) => {
        if (!checkForm(customerValues, customerCheckValues, setCustomerCheckValues, true)) {
            return false
        }
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        setAddCustomer(false)

        const cusBody=JSON.parse(JSON.stringify(customerValues))
        if(globalContext.get.Shop.sho_default_enable_sms){
            cusBody.cus_enable_sms=1
        }
        if(globalContext.get.Shop.sho_default_enable_email){
            cusBody.cus_enable_email=1
        }

        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/customers`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(cusBody)
        })
        const respValue = await resp.json()

        if (resp.status == 200) {

            globalContext.set(draft => {
                draft.customers = [...[respValue.data], ...draft.customers]
            })
            let retrunValue = true
            if (final) {
                retrunValue = respValue.data.ID
            } else {
                setValues(draft => {
                    draft.customer = {
                        label: `${respValue.data.cus_name} ${respValue.data.cus_surname ? respValue.data.cus_surname : ''}`,
                        value: respValue.data.ID
                    };
                    draft.title = `${draft.category ? draft.category.label : ''} ${draft.customer ? draft.customer.label : ''}`
                })
            }

            const phnBody = {
                phn_prefix: customerValues.phn_prefix,
                phn_number: customerValues.phn_number,
                Customer_ID: respValue.data.ID
            }

            const respi = await fetch(`${globalContext.get.backendUrl}/papiv1/PhoneNumbers`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(phnBody)
            })
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['add_client'], textContext.value),
                    ttl: 2000
                })
            })
            serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
            return retrunValue
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_client'], textContext.value),
                    ttl: 2000
                })
            })
            serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
            return false
        }

    }
    const addEventByRequest = (addData) => {
        // serviceContext.set(draft=>{draft.addEvent=false})
        // console.log(addData)
        let customer = globalContext.get.customers.filter(cus =>
            cus.PhoneNumbers.length > 0 &&
            cus.PhoneNumbers[0].phn_prefix == addData.cer_prefix &&
            cus.PhoneNumbers[0].phn_number == addData.cer_number
        )
        if (customer.length == 0 && addData.cer_email) {
            customer = globalContext.get.customers.filter(cus =>
                cus.cus_email == addData.cer_email
            )
        }
        let category = undefined
        if (addData.Category_ID) {
            category = categoryOptions.filter(cati => cati.value.ID == addData.Category_ID)
            if (category.length > 0) {
                category = category[0]
            } else {
                category = undefined
            }
        }
        let cusOpt = false
        if (customer.length > 0) {
            cusOpt = customerOptions.filter(cop => cop.value == customer[0].ID)
            if (cusOpt.length > 0) {
                cusOpt = cusOpt[0]
            } else {
                cusOpt = false
            }
        }

        let start = moment(addData.cer_date, 'X')
        let end = moment(addData.cer_date, 'X').add(1, 'hour')
        let title = undefined
        if (addData.Category) {
            end = moment(addData.cer_date, 'X').add(addData.Category.cat_duration, 'minute')
            if (cusOpt) {
                title = `${addData.Category.cat_name} ${cusOpt.label}`
            } else {
                title = `${addData.Category.cat_name}`
            }
        }


        if (cusOpt) {
            setValues({
                date: start.format('YYYY-MM-DD'),
                start: start.format('HH:mm'),
                end: end.format('HH:mm'),
                allDay: false,
                title: title,
                note: '',
                category: category,
                appointment: true,
                customer: cusOpt,
                contact: true,
                autogen_title: true,
                rec_end: null,
                rec_step: null,
                rec_unit: null,
                owner: { label: globalContext.get.User.use_username, value: globalContext.get.User.ID },
                isRec: false
            })
            setEnd(end.format('HH:mm'))
            setIsAppointment(true)
            setShowAdd(true)
        } else if (addData.cer_name) {
            setValues({
                date: start.format('YYYY-MM-DD'),
                start: start.format('HH:mm'),
                end: end.format('HH:mm'),
                allDay: false,
                title: title,
                note: '',
                category: category,
                appointment: true,
                customer: undefined,
                contact: true,
                autogen_title: true,
                rec_end: null,
                rec_step: null,
                rec_unit: null,
                owner: { label: globalContext.get.User.use_username, value: globalContext.get.User.ID },
                isRec: false
            })
            setCustomerValues({
                cus_name: addData.cer_name,
                cus_surname: addData.cer_surname,
                phn_prefix: `+${addData.cer_prefix}`,
                phn_number: addData.cer_number,
                cus_email: addData.cer_email
            })
            setEnd(end.format('HH:mm'))
            setIsAppointment(true)
            setAddCustomer(true)
            setShowAdd(true)
        } else {
            setValues({
                date: start.format('YYYY-MM-DD'),
                start: start.format('HH:mm'),
                end: end.format('HH:mm'),
                allDay: false,
                title: title,
                note: '',
                category: category,
                appointment: addData.cer_apt,
                customer: undefined,
                contact: true,
                autogen_title: true,
                rec_end: null,
                rec_step: null,
                rec_unit: null,
                owner: { label: globalContext.get.User.use_username, value: globalContext.get.User.ID },
                isRec: false
            })
            setEnd(end.format('HH:mm'))
            setIsAppointment(addData.cer_apt)
            setShowAdd(true)
        }
        if (addData.ID) {
            setCusReqID(addData.ID)
        }
    }
    const checkForm = (values, check, setCheck, show = false) => {
        let pass = true
        //console.log('check')
        Object.keys(values).forEach(k => {
            //console.log(check.check[k])
            try {
                if (check.check[k](values[k])) {

                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.good[k] = true })
                        setCheck(draft => { draft.bad[k] = false })
                    }
                } else {
                    if (k == 'customer') {
                        if (isAppointment && !addCustomer) {
                            pass = false
                        }
                    } else {
                        pass = false
                    }

                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.bad[k] = true })
                        setCheck(draft => { draft.good[k] = false })
                    }
                }
            } catch {
                //console.log('error', k)
            }

        })
        return pass
    }
    const closeAdd = () => {
        setValues({
            date: undefined,
            start: undefined,
            end: undefined,
            allDay: false,
            title: '',
            note: '',
            category: undefined,
            appointment: undefined,
            customer: undefined,
            contact: true,
            autogen_title: true,
            rec_end: null,
            rec_step: null,
            rec_unit: null,
            owner: { label: globalContext.get.User.use_username, value: globalContext.get.User.ID },
            isRec: false
        })
        setFormChecks({
            touched: {
                ID: false,
                date: false,
                start: false,
                end: false,
                allDay: false,
                title: false,
                note: false,
                category: false,
                customer: false,
                owner: false,
                contact: false,
                appointmentID: false,
            },
            check: {
                ID: (v) => { return true },
                date: (v) => { return v },
                start: (v) => { return true },
                end: (v) => { return true },
                allDay: (v) => { return true },
                title: (v) => { return v.length > 0 && v.length < 47 },
                note: (v) => { return v.length < 150 },
                category: (v) => { return v },
                customer: (v) => { return (isAppointment && !addCustomer) ? v : true },
                owner: (v) => { return true },
                contact: (v) => { return true },
                appointmentID: (v) => { return true },
            },
            good: {
                ID: false,
                date: false,
                start: false,
                end: false,
                allDay: false,
                title: false,
                note: false,
                category: false,
                customer: false,
                owner: false,
                contact: false,
                appointmentID: false,
            },
            bad: {
                ID: false,
                date: false,
                start: false,
                end: false,
                allDay: false,
                title: false,
                note: false,
                category: false,
                customer: false,
                owner: false,
                contact: false,
                appointmentID: false,
            },
        })
        setCustomerValues(defaultCustomerValues)
        setCustomerCheckValues({
            touched: {
                cus_name: false,
                cus_surname: false,
                phn_prefix: false,
                phn_number: false,
            },
            check: {
                cus_name: (v) => { return v.length > 0 && v.length < 50 },
                cus_surname: (v) => { return v.length < 50 },
                phn_prefix: (v) => { return v.match(/\+[0-9]{1,3}$/) },
                phn_number: (v) => { return checkNumber(v) },
            },
            good: {
                cus_name: false,
                cus_surname: false,
                phn_prefix: false,
                phn_number: false,
            },
            bad: {
                cus_name: false,
                cus_surname: false,
                phn_prefix: false,
                phn_number: false,
            },
        })
        setEnd(undefined)
        setShowAdd(false)
        setAddCustomer(false)
        setCusReqID(false)
        setIsAppointment(true)
    }
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }
    const setTimeStart = (value) => {

        const startMinutes = parseInt(String(value).substring(0, 2)) * 60 + parseInt(String(value).substring(3, 5))
        const endMinutes = parseInt(String(end).substring(0, 2)) * 60 + parseInt(String(end).substring(3, 5))
        if (startMinutes < endMinutes) {
            setValues(draft => { draft.start = value })
        }

    }
    const setTimeEnd = (value) => {
        const startMinutes = parseInt(String(values.start).substring(0, 2)) * 60 + parseInt(String(values.start).substring(3, 5))
        const endMinutes = parseInt(String(value).substring(0, 2)) * 60 + parseInt(String(value).substring(3, 5))
        if (startMinutes < endMinutes) {
            setEnd(value)
        }

    }
    const switchIsAppointment = (e) => {
        setIsAppointment(e)
        const tempAltCategory = altCategory.current
        altCategory.current = values.category
        setValues(draft => { draft.category = tempAltCategory })
        setRefreshSelect(false)
    }

    useEffect(() => {
    }, [])
    useEffect(() => {
        setCustomerOptions(globalContext.get.customers.map(cus => ({ label: `${cus.cus_name} ${cus.cus_surname ? cus.cus_surname : ''}`, value: cus.ID })))

        //load degli user
        if (globalContext.get.User.ID && globalContext.get.Shop.ID && globalContext.get.Agency.ID) {
            let l_users = []
            let ids = []
            globalContext.get.shops.forEach(sho => {
                sho.Users.forEach(use => {
                    if (!ids.includes(use.ID)) {
                        ids.push(use.ID)
                        l_users.push({ label: use.use_username, value: use.ID })
                    }
                })
            })
            setUserOptions(l_users)
        }
    }, [globalContext.get])
    useEffect(() => {
        if (serviceContext.get.addEvent) {
            addEventByRequest(serviceContext.get.addEvent)
            serviceContext.set(draft => { draft.addEvent = false })
        }
    }, [serviceContext.get])
    useEffect(() => {
        setRefreshSelect(true)
    }, [refreshSelect])
    useEffect(() => {
        checkForm(values, formChecks, setFormChecks)
    }, [values])
    useEffect(()=>{
        if(values&&values.start&&end){
            const startMinutes = parseInt(String(values.start).substring(0, 2)) * 60 + parseInt(String(values.start).substring(3, 5))
            const endMinutes = parseInt(String(end).substring(0, 2)) * 60 + parseInt(String(end).substring(3, 5))
            if (startMinutes > endMinutes) {
                setTimeError(true)
            } else if (timeError) {
                setTimeError(false)
            }
        }
    },[values, end])
    useEffect(() => {
        checkForm(customerValues, customerCheckValues, setCustomerCheckValues)
    }, [customerValues])
    useEffect(() => {
        // console.log(showAddAlert)
    }, [showAddAlert])
    useEffect(() => {
        // console.log(globalContext.get.selectedShop)
        setCustomerValues(draft => { draft.phn_prefix = `+${globalContext.get.selectedShop.sho_default_prefix}` })
    }, [addCustomer])

    return (
        <Modal show={showAdd} onHide={closeAdd} >
            <ModalHeader closeButton>
                <ModalTitle className='nac-title'>{textContext.get(['event', 'new_event'], ['title'], textContext.value)}</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <Form>
                    <Row className='mt-4 mx-4'>
                        <Col className='ms-2 me-3'>
                            <InputGroup hasValidation>
                                <InputGroup.Text>{textContext.get(['event', 'new_event'], ['date'], textContext.value)}</InputGroup.Text>
                                <FormControl
                                    type='date'
                                    value={values.date}
                                    onChange={(e) => setValues(draft => { draft.date = e.target.value })}
                                    onFocus={(e) => setFormChecks(draft => { draft.touched.date = true })}
                                    isValid={formChecks.good.date}
                                    isInvalid={formChecks.bad.date}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                    {(getPermission('gro_aer_event', 0) && getPermission('gro_aer_apt', 0)) ? (
                        <Row className='mt-3 mx-4'>
                            <Col className='ms-2 me-3'>
                                <GoodSwitch
                                    label={textContext.get(['event', 'new_event'], ['is_apt'], textContext.value)}
                                    value={isAppointment}
                                    onChange={switchIsAppointment}
                                />
                            </Col>
                        </Row>
                    ) : (<></>)}
                    <Row className='mt-3 mx-4'>
                        <Col className='ms-2 me-3'>
                            <Form.Label className='light-color'>{textContext.get(['event', 'new_event'], ['select'], textContext.value)}</Form.Label>
                            {refreshSelect ? (
                                <Select
                                    id='select-pdp'
                                    components={animatedComponents}
                                    options={categoryOptions.filter(cat => cat.value.apt == isAppointment && cat.value.ID != 0)}
                                    value={values.category}
                                    onChange={(e) => setValues(draft => { draft.category = e; draft.title = `${draft.category ? draft.category.label : ''} ${draft.customer ? draft.customer.label : ''}`; setTime(e) })}
                                    onFocus={(e) => setFormChecks(draft => { draft.touched.title = true })}
                                    isValid={formChecks.good.title}
                                    isInvalid={formChecks.bad.title}
                                />
                            ) : (
                                <Row className='my-4'>

                                </Row>
                            )}
                        </Col>
                    </Row>
                    {isAppointment && (
                        <>
                            <Row className='mt-3 mx-4'>
                                <Row className='ms-2 me-3'>
                                    <Form.Label className='light-color' style={{ paddingLeft: 0 }} >{textContext.get(['event', 'new_event'], ['select2'], textContext.value)}</Form.Label>
                                    <Col xs={9} style={{ paddingLeft: 0 }}>
                                        <Select
                                            id='select-pep'
                                            components={animatedComponents}
                                            options={customerOptions}
                                            isSearchable={true}
                                            value={values.customer}
                                            onChange={(e) => setValues(draft => { draft.customer = e; draft.title = `${draft.category ? draft.category.label : ''} ${draft.customer ? draft.customer.label : ''}` })}
                                            onFocus={(e) => setFormChecks(draft => { draft.touched.customer = true })}
                                            isValid={formChecks.good.customer}
                                            isInvalid={formChecks.bad.customer}
                                        />
                                    </Col>
                                    {getPermission('gro_aer_customer', 0) ? (
                                        <>
                                            {addCustomer ? (
                                                <Col xs={2} className='ms-4'>
                                                    <RiUserUnfollowLine onClick={() => setAddCustomer(false)} style={{ cursor: 'pointer' }} className='calendar-customer-add-button' size={`24pt`} />
                                                </Col>
                                            ) : (
                                                <Col xs={2} className='ms-4'>
                                                    <RiUserAddLine onClick={() => setAddCustomer(true)} style={{ cursor: 'pointer' }} className='calendar-customer-add-button' size={`24pt`} />
                                                </Col>
                                            )}
                                        </>
                                    ) : (<></>)}
                                </Row>
                                {addCustomer ? (
                                    <>
                                        <Row className='mt-4'>
                                            <Col className='ms-2 me-3'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['event', 'new_event'], ['name'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type='text'
                                                        placeholder={textContext.get(['event', 'new_event'], ['name'], textContext.value)}
                                                        value={customerValues.cus_name}
                                                        onChange={(e) => {
                                                            setCustomerValues(draft => { draft.cus_name = e.target.value }); 
                                                            setValues(draft => { draft.title = `${draft.category ? draft.category.label : ''} ${e.target.value} ${customerValues.cus_surname ? customerValues.cus_surname : ''}` })
                                                        }}
                                                        onFocus={(e) => setCustomerCheckValues(draft => { draft.touched.cus_name = true })}
                                                        isValid={customerCheckValues.good.cus_name}
                                                        isInvalid={customerCheckValues.bad.cus_name}
                                                    />
                                                    <FormControl
                                                        type='text'
                                                        placeholder={textContext.get(['event', 'new_event'], ['surname'], textContext.value)}
                                                        value={customerValues.cus_surname}
                                                        onChange={(e) => {
                                                            setCustomerValues(draft => { draft.cus_surname = e.target.value }); 
                                                            setValues(draft => { draft.title = `${draft.category ? draft.category.label : ''} ${customerValues.cus_name ? customerValues.cus_name : ''} ${e.target.value}` })
                                                        }}
                                                        onFocus={(e) => setCustomerCheckValues(draft => { draft.touched.cus_surname = true })}
                                                        isValid={customerCheckValues.good.cus_surname}
                                                        isInvalid={customerCheckValues.bad.cus_surname}
                                                    />
                                                </InputGroup>
                                            </Col>
                                        </Row>
                                        <Row className='mt-4'>
                                            <Col className='ms-2 me-3'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['event', 'new_event'], ['phone'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        placeholder='+41'
                                                        style={{ maxWidth: "calc(var(--text-font-size) * 4)" }}
                                                        value={customerValues.phn_prefix}
                                                        onChange={e => setCustomerValues(draft => { draft.phn_prefix = e.target.value })}
                                                        onFocus={(e) => setCustomerCheckValues(draft => { draft.touched.phn_prefix = true })}
                                                        isValid={customerCheckValues.good.phn_prefix}
                                                        isInvalid={customerCheckValues.bad.phn_prefix}
                                                    />
                                                    <FormControl
                                                        type="text"
                                                        placeholder='76 579 43 67'
                                                        value={customerValues.phn_number}
                                                        onChange={e => setCustomerValues(draft => { draft.phn_number = e.target.value })}
                                                        onFocus={(e) => setCustomerCheckValues(draft => { draft.touched.phn_number = true })}
                                                        isValid={customerCheckValues.good.phn_number}
                                                        isInvalid={customerCheckValues.bad.phn_number}
                                                    />
                                                </InputGroup>
                                            </Col>
                                        </Row>
                                    </>) : (<></>)}
                            </Row>
                            <Row className='mt-3 mx-4'>
                                <Col className='ms-2 me-3'>
                                    <GoodSwitch
                                        label={textContext.get(['event', 'new_event'], ['is_contact'], textContext.value)}
                                        value={values.contact}
                                        onChange={(e) => { setValues(draft => { draft.contact = e }) }}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                    {globalContext.get.Agency.age_max_users != 1 ?
                    <Row className='mt-3 mx-4'>
                        <Col className='ms-2 me-3'>
                            <Form.Label className='light-color'>{textContext.get(['event', 'new_event'], ['ass'], textContext.value)}</Form.Label>
                            <Select
                                id='select-pdwp'
                                components={animatedComponents}
                                options={userOptions}
                                value={values.owner}
                                onChange={(e) => setValues(draft => {draft.owner=e})}
                            />
                        </Col>
                    </Row>
                    :<></>}
                    <hr />
                    <Row className='mt-3 mx-4'>
                        <Col className='ms-2 me-3'>
                            <GoodSwitch
                                label={textContext.get(['event', 'new_event'], ['total'], textContext.value)}
                                value={values.allDay}
                                onChange={(e) => { setValues(draft => { draft.allDay = e }) }}
                            />
                        </Col>
                    </Row>
                    {!values.allDay && (
                        <Row className='mt-1 mb-4 mx-4'>
                            <Col className='ms-2 me-3'>
                                <InputGroup hasValidation>
                                    <InputGroup.Text>{textContext.get(['event', 'new_event'], ['start'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='time'
                                        value={values.start}
                                        max={end}
                                        onChange={(e) => setValues(draft=>{draft.start=e.target.value})}
                                        className={`${timeError?'form-error':''}`}

                                    />
                                </InputGroup>
                            </Col>
                            <Col className='ms-3 me-2'>
                                <InputGroup hasValidation>
                                    <InputGroup.Text>{textContext.get(['event', 'new_event'], ['finish'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='time'
                                        value={end}
                                        min={values.start}
                                        onChange={(e) => setEnd(e.target.value)}
                                        className={`${timeError?'form-error':''}`}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                    )}
                    <Row className='my-3 mx-4'>
                        <Col className='ms-2 me-3'>
                            <GoodSwitch
                                label={textContext.get(['event', 'info_event'], ['event_rec'], textContext.value)}
                                value={values.isRec}
                                onChange={(e) => { changeRec(e) }}
                            />
                        </Col>
                    </Row>
                    {values.isRec ? (
                        <>
                            <Row className='mt-1 mb-4 mx-4'>
                                <InputGroup hasValidation>
                                    <InputGroup.Text>{textContext.get(['event', 'info_event'], ['og'], textContext.value)}</InputGroup.Text>
                                    <GoodNumber
                                        value={values.rec_step}
                                        min={1}
                                        classes='form-control'
                                        onChange={(e) => setValues(draft => { draft.rec_step = e })}
                                    />
                                    <Select
                                        id='select-pep'
                                        components={animatedComponents}
                                        options={recUnitOptions}
                                        isSearchable={false}
                                        value={values.rec_unit}
                                        onChange={(e) => setValues(draft => { draft.rec_unit = e })}
                                    />
                                </InputGroup>
                            </Row>
                            <Row className='mt-4 mx-4'>
                                <Col >
                                    <InputGroup hasValidation>
                                        <InputGroup.Text>{textContext.get(['event', 'info_event'], ['fin_rec'], textContext.value)}</InputGroup.Text>
                                        <FormControl
                                            type='date'
                                            value={values.rec_end}
                                            onChange={(e) => setValues(draft => { draft.rec_end = e.target.value })}
                                        />
                                    </InputGroup>
                                    <p className='nac-text'>{textContext.get(['event', 'info_event'], ['fin_description'], textContext.value)}</p>
                                </Col>
                            </Row>
                        </>
                    ) : (<></>)}
                    <hr />
                    {/* <Row className='my-3 mx-4'>
                        <Col className='ms-2 me-3'>
                            <GoodSwitch
                                label={textContext.get(['event', 'info_event'], ['divieto'], textContext.value)}
                                value={values.autogen_title}
                                onChange={(e) => setValues(draft=>{draft.autogen_title=e})}
                            />
                        </Col>
                    </Row> */}
                    <Row className='mt-4 mx-4'>
                        <Col className='ms-2 me-3'>
                            <InputGroup hasValidation>
                                <InputGroup.Text>{textContext.get(['event', 'new_event'], ['title2'], textContext.value)}</InputGroup.Text>
                                <FormControl
                                    type='text'
                                    value={values.title}
                                    onChange={(e) => setValues(draft => { draft.title = e.target.value })}
                                    onFocus={(e) => setFormChecks(draft => { draft.touched.title = true })}
                                    isValid={formChecks.good.title}
                                    isInvalid={formChecks.bad.title}
                                    // disabled={values.autogen_title}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row className='mt-4 mx-4'>
                        <Col className='ms-2 me-3'>
                            <InputGroup hasValidation>
                                <InputGroup.Text>{textContext.get(['event', 'new_event'], ['notes'], textContext.value)}</InputGroup.Text>
                                <FormControl
                                    type='text'
                                    as="textarea"
                                    value={values.note}
                                    onChange={(e) => setValues(draft => { draft.note = e.target.value })}
                                    onFocus={(e) => setFormChecks(draft => { draft.touched.note = true })}
                                    isValid={formChecks.good.note}
                                    isInvalid={formChecks.bad.note}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                    <hr />
                    <Row className='mt-4 mb-2 mx-4'>
                        <Col xs={9} >
                        </Col>
                        <Col xs={2} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button' onClick={closeAdd}>
                                <RiCloseLine size={`24pt`} />
                            </button>
                        </Col>
                        <Col xs={1} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button' onClick={handleSubmit}>
                                <RiCheckLine size={`24pt`} />
                            </button>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default EventEditor